import { useContext, useEffect } from "react";
import { isEmpty } from "lodash";
import { Table } from "react-bootstrap";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import CustomModal from "../../../helpers/CustomModal/CustomModal";

import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";

import EmptyItems from "../../../helpers/EmptyItems/EmptyItems";
import { userAdminContext } from "../../../context/Admin/UserAdminContext/UserAdminContext";
import { convertRoleToText, userRoleItems } from "../../../utils/enum";

const UserAdmin = () => {
  const {
    users,
    userId,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    phoneNumber,
    setPhoneNumber,
    role,
    setRole,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    isShowModal,
    handleShowModal,
    handleHideModal,
    handleGetUsers,
    handleCreateUser,
    handleEditUser,
    handleChangeUserConfirm,
    handleDeleteUser,
  } = useContext(userAdminContext);

  useEffect(() => {
    handleGetUsers();
  }, []);

  return (
    <>
      <SiteTitle title="مدیریت منو" />

      <div className="container-fluid mt-4">
        <button type="button" className="kf-btn mb-3" onClick={handleShowModal}>
          <span>افزودن کاربر</span>
        </button>

        {isEmpty(users) ? (
          <EmptyItems />
        ) : (
          <div className="card">
            <Table responsive hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>نام</th>
                  <th>نام خانوادگی</th>
                  <th>شماره همراه</th>
                  <th>نقش</th>
                  <th>وضعیت</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {users.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.firstName}</td>
                    <td>{item.lastName}</td>
                    <td>{item.phoneNumber}</td>
                    <td>{convertRoleToText(item.role)}</td>
                    <td>
                      {item.isConfirm ? (
                        <i className="la la-check text-success" />
                      ) : (
                        <i className="la la-times text-danger" />
                      )}
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn-primary mx-2"
                        onClick={() => handleShowModal(item)}
                      >
                        ویرایش
                      </button>
                      <button
                        type="button"
                        className={`btn-${
                          !item.isConfirm ? "success" : "danger"
                        } mx-2`}
                        onClick={() =>
                          areYouSureMessage(
                            () => handleChangeUserConfirm(item._id),
                            `آیا از ${
                              !item.isConfirm ? "فعال" : "غیرفعال"
                            } کردن کاربر ${item.firstName} ${
                              item.lastName
                            } مطمئنید؟`
                          )
                        }
                      >
                        {!item.isConfirm ? "فعال" : "غیرفعال"}
                      </button>
                      <button
                        type="button"
                        className="btn-danger mx-2"
                        onClick={() =>
                          areYouSureMessage(
                            () => handleDeleteUser(item._id),
                            `آیا از حذف ${item.firstName} ${item.lastName} مطمئنید؟`
                          )
                        }
                      >
                        حذف
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </div>
      {/* Start Add OR Edit Modal */}
      <CustomModal
        size="lg"
        title={`${userId ? "ویرایش" : "افزودن"} آیتم منو`}
        show={isShowModal}
        onHide={handleHideModal}
      >
        <form onSubmit={userId ? handleEditUser : handleCreateUser}>
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="kf-field">
                <input
                  type="text"
                  name="firstName"
                  placeholder="نام"
                  onChange={(e) => setFirstName(e.target.value)}
                  value={firstName}
                />
                <i className="la la-user" />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="kf-field">
                <input
                  type="text"
                  name="lastName"
                  placeholder="نام خانوادگی"
                  onChange={(e) => setLastName(e.target.value)}
                  value={lastName}
                />
                <i className="la la-user" />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="kf-field">
                <input
                  type="text"
                  name="phoneNumber"
                  placeholder="شماره موبایل"
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  value={phoneNumber}
                />
                <i className="la la-user" />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="kf-field">
                <select
                  type="text"
                  name="role"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                >
                  <option selected disabled hidden value="">
                    نقش
                  </option>
                  {userRoleItems.map((item) => (
                    <option
                      className="bg-dark"
                      key={item}
                      value={item}
                      selected={item === role}
                    >
                      {convertRoleToText(item)}
                    </option>
                  ))}
                </select>
                <i className="la la-lock" />
              </div>
            </div>
            {!userId && (
              <>
                <div className="col-12 col-md-6">
                  <div className="kf-field">
                    <input
                      type="password"
                      name="password"
                      placeholder="کلمه عبور"
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                    />
                    <i className="la la-lock" />
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="kf-field">
                    <input
                      type="password"
                      name="confirmPassword"
                      placeholder="تکرار کلمه عبور"
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      value={confirmPassword}
                    />
                    <i className="la la-lock" />
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="kf-bts mt-4">
            <button className="kf-btn" type="submit">
              <span>{userId ? "ویرایش" : "اضافه"}</span>
            </button>

            <button
              type="button"
              className="btn btn-danger me-2"
              onClick={handleHideModal}
            >
              انصراف
            </button>
          </div>
        </form>
      </CustomModal>
      {/* End Add OR Edit Modal */}
    </>
  );
};

export default UserAdmin;
